module.exports = __webpack_public_path__ + "static/media/logo.a390a33d.svg";